import { styled } from '@mui/material/styles';
import { flowRight } from 'lodash';
import { SELECT_DATE } from 'common/constants/inputs';
import withRequired from 'components/WithRequired/withRequired';
import withTooltip from 'components/WithTooltip';
import { useLayoutContext } from 'context/LayoutContext';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { slashFormat } from 'utilities';
import { DateInput } from 'utilities/slashFormat/slashFormat';

interface GridDateValueViewerProps {
  cell: ICell;
  value?: string;
}

const PREFIX = 'GridDateValueViewer';

const classes = {
  valueViewer: `${PREFIX}-valueViewer`,
  valueContainer: `${PREFIX}-valueContainer`,
  margin: `${PREFIX}-margin`,
};

const Root = styled('div')(({ theme }) => ({
  [`&.${classes.valueViewer}`]: {
    position: 'absolute',
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    right: 0,
    top: 0,
  },

  [`& .${classes.valueContainer}`]: {
    position: 'relative',
    height: 'inherit',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },

  [`& .${classes.margin}`]: {
    marginRight: theme.spacing(3),
  },
}));

const GridDateValueViewer = ({ cell }: GridDateValueViewerProps) => {
  const { isExportMode } = useLayoutContext();

  const { value } = cell;

  if (cell.hidden) {
    return null;
  }
  const displayedValue = slashFormat(value as DateInput);

  const label = displayedValue || SELECT_DATE;
  const isSelectDate = label === SELECT_DATE;

  return (
    <Root className={classes.valueViewer} sx={{ height: '100%' }}>
      <div className={`${classes.valueContainer} ${classes.margin}`} id={`${cell.key}-date_viewer`}>
        <span>{isExportMode && isSelectDate ? '' : label}</span>
      </div>
    </Root>
  );
};

const enhance = flowRight(withRequired);

export default withTooltip(enhance(GridDateValueViewer));
